import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../types/api-response";
import axios from "../../utils/axiosInceptor";
import { apiV1Endpoint } from "./endpoints";

export type MasterUsers = {
  id: string;
  name: string;
  mobile: string;
  email: string;
  userId: string;
  status: string;
  createdAt: string;
  properties: string[];
};

type UseGetMasterUsersOptions = {
  isEnabled?: boolean;
};

const getMasterUsers = async () => {
  const url = `${apiV1Endpoint}/masterUser`;
  const response = await axios.get<ApiResponse<MasterUsers[]>>(url);
  return response.data.result;
};

export const useGetMasterUsers = (options: UseGetMasterUsersOptions = {}) => {
  const { isEnabled } = options;

  const { data, isLoading } = useQuery({
    queryKey: ["master-users"],
    queryFn: getMasterUsers,
    enabled: isEnabled,
    refetchOnWindowFocus: false, // 👈 disable auto refetch when window regains focus
  });

  return {
    masterUsers: data ?? [],
    isLoadingMasterUsers: isLoading,
  };
};
